module.exports = __webpack_public_path__ + "static/media/logo-worldbank.85c03736.svg";